import { HoverCard } from "../../components/ui";
import type { AgentAttribution, AgentVisibility } from "../api/e2e";

import "./RunVisibilityHoverCard.css";

function PublicRunIcon() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <circle cx="8" cy="8" r="5.75" />
      <path d="M2.5 8h11M8 2.25c1.55 1.58 2.35 3.5 2.35 5.75S9.55 12.17 8 13.75C6.45 12.17 5.65 10.25 5.65 8S6.45 3.83 8 2.25Z" />
    </svg>
  );
}

export default function RunVisibilityHoverCard({
  visibility,
  startedBy,
}: {
  visibility: AgentVisibility;
  startedBy: AgentAttribution | null;
}) {
  if (visibility === "private") return null;
  const runner = startedBy?.display_name || startedBy?.email || null;
  const label = runner ? `Public run started by ${runner}` : "Public run";

  return (
    <HoverCard
      label={label}
      trigger={<PublicRunIcon />}
      className="run-visibility-hover__trigger"
    >
      <div className="run-visibility-hover">
        <strong>Public run</strong>
        <span>{runner ? `Started by ${runner}` : "Runner unavailable"}</span>
      </div>
    </HoverCard>
  );
}
